export const COOKIE_AUTH = {
  TOKEN: "palm-token",
  TOKEN_EXPIRE_DAYS: 9000,
	USER: "palm-user"
};
